/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';

import {theme} from 'components/shared/theme';

const {
  colors,
  loaderSize,
  spacing
} = theme;

export const Loader = styled.default.div<{color?: 'dark' | 'light'}>`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  margin: 0 auto;

  & span {
    margin: 0 ${spacing.xxSmall};
    width: ${loaderSize.large}px;
    height: ${loaderSize.large}px;
    display: block;
    position: relative;
    border-radius: 50%;
    border-color: ${({color}) => color === 'light' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(150, 150, 150, 0.5)'};
    border-style: solid;
    border-width: ${loaderSize.large / 5}px;

    &:after{
      content: '';
      position: absolute;
      top: -${loaderSize.large / 5}px;
      left: -${loaderSize.large / 5}px;
      right: -${loaderSize.large / 5}px;
      bottom: -${loaderSize.large / 5}px;
      border: ${loaderSize.large / 5}px solid transparent;
      border-top-color: ${({color}) => color === 'dark' ? colors.gray700 : colors.white};
      border-radius: 50%;
      animation: rotation 1s linear infinite;
    }
  }
  &.small span {
    width: ${loaderSize.small}px;
    height: ${loaderSize.small}px;
    border-width: ${loaderSize.small / 5}px;
    &:after {
      top: -${loaderSize.small / 5}px;
      left: -${loaderSize.small / 5}px;
      right: -${loaderSize.small / 5}px;
      bottom: -${loaderSize.small / 5}px;
      border-width: ${loaderSize.small / 5}px;
    }
  }
  &.medium span {
    width: ${loaderSize.medium}px;
    height: ${loaderSize.medium}px;
    border-width: ${loaderSize.medium / 5}px;
    &:after {
      top: -${loaderSize.medium / 5}px;
      left: -${loaderSize.medium / 5}px;
      right: -${loaderSize.medium / 5}px;
      bottom: -${loaderSize.medium / 5}px;
      border-width: ${loaderSize.medium / 5}px;
    }
  }
  &.large span {
    width: ${loaderSize.large}px;
    height: ${loaderSize.large}px;
    border-width: ${loaderSize.large / 5}px;
    &:after {
      top: -${loaderSize.large / 5}px;
      left: -${loaderSize.large / 5}px;
      right: -${loaderSize.large / 5}px;
      bottom: -${loaderSize.large / 5}px;
      border-width: ${loaderSize.large / 5}px;
    }
  }
`;